import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';

const useFetchRoleActions = (fetch, category, code, readStatus, showDialog) => {
  const dependencies = showDialog ? [readStatus] : [];
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(code, category, showDialog);
    }
  }, dependencies);
};

export default {
  useFetchRoleActions,
};
